import { application } from "./application"

import AccordionController from "./accordion_controller"
application.register("accordion", AccordionController)

import AddressAutocompleteController from "./address_autocomplete_controller"
application.register("address-autocomplete", AddressAutocompleteController)

import AdminTagsController from "./admin_tags_controller"
application.register("admin-tags", AdminTagsController)

import AfterHoursRoutingController from "./after_hours_routing_controller"
application.register("after-hours-routing", AfterHoursRoutingController)

import AgedBucketShiftController from "./aged_bucket_shift_controller"
application.register("aged-bucket-shift", AgedBucketShiftController)

import AgedLeadAvailabilityController from "./aged_lead_availability_controller"
application.register("aged-lead-availability", AgedLeadAvailabilityController)

import AgencyDepositController from "./agency_deposit_controller"
application.register("agency-deposit", AgencyDepositController)

import AgencyMatchOptinController from "./agency_match_optin_controller"
application.register("agency-match-optin", AgencyMatchOptinController)


import AiCurationCoverageController from "./ai_curation_coverage_controller"
application.register("ai-curation-coverage", AiCurationCoverageController)

import AnalyticsWidgetsController from "./analytics_widgets_controller"
application.register("analytics-widgets", AnalyticsWidgetsController)

import AppSettingConfirmController from "./app_setting_confirm_controller"
application.register("app-setting-confirm", AppSettingConfirmController)

import ConfirmSubmitController from "./confirm_submit_controller"
application.register("confirm-submit", ConfirmSubmitController)

import LineCheckCallConfirmController from "./line_check_call_confirm_controller"
application.register("line-check-call-confirm", LineCheckCallConfirmController)

import LineCheckPollController from "./line_check_poll_controller"
application.register("line-check-poll", LineCheckPollController)

import OpenCreateModalController from "./open_create_modal_controller"
application.register("open-create-modal", OpenCreateModalController)

import SwitchOnWarningController from "./switch_on_warning_controller"
application.register("switch-on-warning", SwitchOnWarningController)
import SubmitOnWarningController from "./submit_on_warning_controller"
application.register("submit-on-warning", SubmitOnWarningController)

import KeySequenceController from "./key_sequence_controller"
application.register("key-sequence", KeySequenceController)

import SingleSubmitController from "./single_submit_controller"
application.register("single-submit", SingleSubmitController)

import NativeSubmitBusyController from "./native_submit_busy_controller"
application.register("native-submit-busy", NativeSubmitBusyController)

import AppSettingFileSizeController from "./app_setting_file_size_controller"
application.register("app-setting-file-size", AppSettingFileSizeController)

import AppSettingListSelectController from "./app_setting_list_select_controller"
application.register("app-setting-list-select", AppSettingListSelectController)

import AppSettingModalController from "./app_setting_modal_controller"
application.register("app-setting-modal", AppSettingModalController)

import AppSettingToggleController from "./app_setting_toggle_controller"
application.register("app-setting-toggle", AppSettingToggleController)

import AppSettingsSearchController from "./app_settings_search_controller"
application.register("app-settings-search", AppSettingsSearchController)

import AppVersionPopoverController from "./app_version_popover_controller"
application.register("app-version-popover", AppVersionPopoverController)

import AppointmentDetailModalController from "./appointment_detail_modal_controller"
application.register("appointment-detail-modal", AppointmentDetailModalController)

import AppointmentStatusActionsController from "./appointment_status_actions_controller"
application.register("appointment-status-actions", AppointmentStatusActionsController)

import AutoDetectTimeZoneController from "./auto_detect_time_zone_controller"
application.register("auto-detect-time-zone", AutoDetectTimeZoneController)

import AutoModalController from "./auto_modal_controller"
application.register("auto-modal", AutoModalController)

import AutoSubmitController from "./auto_submit_controller"
application.register("auto-submit", AutoSubmitController)

import AutocompleteInputController from "./autocomplete_input_controller"
application.register("autocomplete-input", AutocompleteInputController)

import BadgeCelebrationController from "./badge_celebration_controller"
application.register("badge-celebration", BadgeCelebrationController)
import FirstSaleCelebrationController from "./first_sale_celebration_controller"
application.register("first-sale-celebration", FirstSaleCelebrationController)

import AcknowledgeToastController from "./acknowledge_toast_controller"
application.register("acknowledge-toast", AcknowledgeToastController)

import BadgeEmailToggleController from "./badge_email_toggle_controller"
application.register("badge-email-toggle", BadgeEmailToggleController)


import BlackoutDatesController from "./blackout_dates_controller"
application.register("blackout-dates", BlackoutDatesController)

import BlogAiWriterController from "./blog_ai_writer_controller"
application.register("blog-ai-writer", BlogAiWriterController)

import BlogCtaController from "./blog_cta_controller"
application.register("blog-cta", BlogCtaController)

import BlogSeoPreviewController from "./blog_seo_preview_controller"
application.register("blog-seo-preview", BlogSeoPreviewController)

import BlogTagChipsController from "./blog_tag_chips_controller"
application.register("blog-tag-chips", BlogTagChipsController)

import BookingDefaultsController from "./booking_defaults_controller"
application.register("booking-defaults", BookingDefaultsController)
import EventMeetingOptionsController from "./event_meeting_options_controller"
application.register("event-meeting-options", EventMeetingOptionsController)

import BookingQuestionFormController from "./booking_question_form_controller"
application.register("booking-question-form", BookingQuestionFormController)

import BrandingResetController from "./branding_reset_controller"
application.register("branding-reset", BrandingResetController)

import BrandingSettingsController from "./branding_settings_controller"
application.register("branding-settings", BrandingSettingsController)

import BucketMaintController from "./bucket_maint_controller"
application.register("bucket-maint", BucketMaintController)

import LeadDemandBuildController from "./lead_demand_build_controller"
application.register("lead-demand-build", LeadDemandBuildController)

import LeadProfileChecklistController from "./lead_profile_checklist_controller"
application.register("lead-profile-checklist", LeadProfileChecklistController)

import StoreOrderModalController from "./store_order_modal_controller"
application.register("store-order-modal", StoreOrderModalController)

import StoreOrderTabsController from "./store_order_tabs_controller"
application.register("store-order-tabs", StoreOrderTabsController)

import PhoneNumberPurchaseController from "./phone_number_purchase_controller"
application.register("phone-number-purchase", PhoneNumberPurchaseController)

import TemplatePopupController from "./template_popup_controller"
application.register("template-popup", TemplatePopupController)

import ThankYouDefaultsPromptController from "./thank_you_defaults_prompt_controller"
application.register("thank-you-defaults-prompt", ThankYouDefaultsPromptController)

import ThankYouStepController from "./thank_you_step_controller"
application.register("thank-you-step", ThankYouStepController)
import ThankYouPreviewController from "./thank_you_preview_controller"
application.register("thank-you-preview", ThankYouPreviewController)

import TitleSuggestionsController from "./title_suggestions_controller"
application.register("title-suggestions", TitleSuggestionsController)

import ThankYouNudgeController from "./thank_you_nudge_controller"
application.register("thank-you-nudge", ThankYouNudgeController)

import WinbackSendController from "./winback_send_controller"
application.register("winback-send", WinbackSendController)

import WinbackPreviewController from "./winback_preview_controller"
application.register("winback-preview", WinbackPreviewController)

import WinbackStatsController from "./winback_stats_controller"
application.register("winback-stats", WinbackStatsController)

import BulkSelectController from "./bulk_select_controller"
application.register("bulk-select", BulkSelectController)

import BusinessInfoGateController from "./business_info_gate_controller"
application.register("business-info-gate", BusinessInfoGateController)

import CalendarAvailabilityController from "./calendar_availability_controller"
application.register("calendar-availability", CalendarAvailabilityController)

import CardDirtyController from "./card_dirty_controller"
application.register("card-dirty", CardDirtyController)

import TermsGateController from "./terms_gate_controller"
application.register("terms-gate", TermsGateController)
import WebhookOrderPickerController from "./webhook_order_picker_controller"
application.register("webhook-order-picker", WebhookOrderPickerController)

import CarrierFormController from "./carrier_form_controller"
application.register("carrier-form", CarrierFormController)

import CarrierPanelController from "./carrier_panel_controller"
application.register("carrier-panel", CarrierPanelController)
import NiprDataFrameController from "./nipr_data_frame_controller"
application.register("nipr-data-frame", NiprDataFrameController)

import NiprResultNoticeController from "./nipr_result_notice_controller"
application.register("nipr-result-notice", NiprResultNoticeController)


import CarrierSearchController from "./carrier_search_controller"
application.register("carrier-search", CarrierSearchController)

import CartController from "./cart_controller"
application.register("cart", CartController)

import ChangeEmailController from "./change_email_controller"
application.register("change-email", ChangeEmailController)

import ChangeNpnController from "./change_npn_controller"
application.register("change-npn", ChangeNpnController)

import ChangePhoneController from "./change_phone_controller"
application.register("change-phone", ChangePhoneController)

import ChartThemeController from "./chart_theme_controller"
application.register("chart-theme", ChartThemeController)

import CheckoutPreflightController from "./checkout_preflight_controller"
application.register("checkout-preflight", CheckoutPreflightController)

import ClearableInputController from "./clearable_input_controller"
application.register("clearable-input", ClearableInputController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import CollapsibleController from "./collapsible_controller"
application.register("collapsible", CollapsibleController)
import SwitchRevealController from "./switch_reveal_controller"
application.register("switch-reveal", SwitchRevealController)

import ColorPickerController from "./color_picker_controller"
application.register("color-picker", ColorPickerController)

import ConfettiController from "./confetti_controller"
application.register("confetti", ConfettiController)

import CopyDefaultsController from "./copy_defaults_controller"
application.register("copy-defaults", CopyDefaultsController)

import CopyFromProfileController from "./copy_from_profile_controller"
application.register("copy-from-profile", CopyFromProfileController)

import CountryCodeController from "./country_code_controller"
application.register("country-code", CountryCodeController)

import CouponCodeController from "./coupon_code_controller"
application.register("coupon-code", CouponCodeController)

import CouponAudienceController from "./coupon_audience_controller"
application.register("coupon-audience", CouponAudienceController)

import CouponCodeFormController from "./coupon_code_form_controller"
application.register("coupon-code-form", CouponCodeFormController)

import CouponEmailAgentController from "./coupon_email_agent_controller"
application.register("coupon-email-agent", CouponEmailAgentController)

import CredentialsGateController from "./credentials_gate_controller"
application.register("credentials-gate", CredentialsGateController)

import CrmUnreadBadgeController from "./crm_unread_badge_controller"
application.register("crm-unread-badge", CrmUnreadBadgeController)

import CustomFieldsController from "./custom_fields_controller"
application.register("custom-fields", CustomFieldsController)

import DashboardFiltersController from "./dashboard_filters_controller"
application.register("dashboard-filters", DashboardFiltersController)

import DatabaseFieldConfigsController from "./database_field_configs_controller"
application.register("database-field-configs", DatabaseFieldConfigsController)

import DateRangeFilterController from "./date_range_filter_controller"
application.register("date-range-filter", DateRangeFilterController)

import DeliveryDaysSummaryController from "./delivery_days_summary_controller"
application.register("delivery-days-summary", DeliveryDaysSummaryController)

import DemandForecastController from "./demand_forecast_controller"
application.register("demand-forecast", DemandForecastController)

import EmailEditController from "./email_edit_controller"
application.register("email-edit", EmailEditController)

import EmailTagsController from "./email_tags_controller"
application.register("email-tags", EmailTagsController)

import EmailVerificationPollerController from "./email_verification_poller_controller"
application.register("email-verification-poller", EmailVerificationPollerController)

import ExportProfileFormController from "./export_profile_form_controller"
application.register("export-profile-form", ExportProfileFormController)

import FileDropController from "./file_drop_controller"
application.register("file-drop", FileDropController)

import FilterPanelController from "./filter_panel_controller"
application.register("filter-panel", FilterPanelController)

import GlModalFocusTrapController from "./gl_modal_focus_trap_controller"
application.register("gl-modal-focus-trap", GlModalFocusTrapController)
import GlInfoDetailsController from "./gl_info_details_controller"
application.register("gl-info-details", GlInfoDetailsController)

import GlToastController from "./gl_toast_controller"
application.register("gl-toast", GlToastController)

import GoatProfilePhoneController from "./goat_profile_phone_controller"
application.register("goat-profile-phone", GoatProfilePhoneController)

import GoalsGateController from "./goals_gate_controller"
application.register("goals-gate", GoalsGateController)

import ImagePreviewController from "./image_preview_controller"
application.register("image-preview", ImagePreviewController)

import ImoAgencyConfirmationController from "./imo_agency_confirmation_controller"
application.register("imo-agency-confirmation", ImoAgencyConfirmationController)

import ImpersonationReplyConfirmController from "./impersonation_reply_confirm_controller"
application.register("impersonation-reply-confirm", ImpersonationReplyConfirmController)

import ImoAgencyController from "./imo_agency_controller"
application.register("imo-agency", ImoAgencyController)

import ImportWizardController from "./import_wizard_controller"
application.register("import-wizard", ImportWizardController)
import ImportResultsRefreshController from "./import_results_refresh_controller"
application.register("import-results-refresh", ImportResultsRefreshController)
import ImportVendorAddController from "./import_vendor_add_controller"
application.register("import-vendor-add", ImportVendorAddController)

import IntegrationFieldsMatrixController from "./integration_fields_matrix_controller"
application.register("integration-fields-matrix", IntegrationFieldsMatrixController)

import LandingPageController from "./landing_page_controller"
application.register("landing-page", LandingPageController)

import LeadFlowFiltersController from "./lead_flow_filters_controller"
application.register("lead-flow-filters", LeadFlowFiltersController)

import LeadOrderFormController from "./lead_order_form_controller"
application.register("lead-order-form", LeadOrderFormController)


import LeadPrefsGateController from "./lead_prefs_gate_controller"
application.register("lead-prefs-gate", LeadPrefsGateController)

import LeadPricingPackageFormController from "./lead_pricing_package_form_controller"
application.register("lead-pricing-package-form", LeadPricingPackageFormController)

import LeadQualityInfoController from "./lead_quality_info_controller"
application.register("lead-quality-info", LeadQualityInfoController)

import LeadVoucherFormController from "./lead_voucher_form_controller"
application.register("lead-voucher-form", LeadVoucherFormController)

import LicensedStatesModalController from "./licensed_states_modal_controller"
application.register("licensed-states-modal", LicensedStatesModalController)

import LockedFeatureController from "./locked_feature_controller"
application.register("locked-feature", LockedFeatureController)

import LogoShapePreviewController from "./logo_shape_preview_controller"
application.register("logo-shape-preview", LogoShapePreviewController)

import LrpAgreementController from "./lrp_agreement_controller"
application.register("lrp-agreement", LrpAgreementController)

import McpGrantFormController from "./mcp_grant_form_controller"
application.register("mcp-grant-form", McpGrantFormController)

import MergeFieldPickerController from "./merge_field_picker_controller"
application.register("merge-field-picker", MergeFieldPickerController)

import MobileDropdownController from "./mobile_dropdown_controller"
application.register("mobile-dropdown", MobileDropdownController)

import MobileSidebarController from "./mobile_sidebar_controller"
application.register("mobile-sidebar", MobileSidebarController)

import ModalFormResetController from "./modal_form_reset_controller"
application.register("modal-form-reset", ModalFormResetController)

import MoreMenuController from "./more_menu_controller"
application.register("more-menu", MoreMenuController)

import MultiSelectController from "./multi_select_controller"
application.register("multi-select", MultiSelectController)

import NotificationGateController from "./notification_gate_controller"
application.register("notification-gate", NotificationGateController)

import NotificationPdfLinkController from "./notification_pdf_link_controller"
application.register("notification-pdf-link", NotificationPdfLinkController)

import NotificationSettingsController from "./notification_settings_controller"
application.register("notification-settings", NotificationSettingsController)

import NotificationsDropdownController from "./notifications_dropdown_controller"
application.register("notifications-dropdown", NotificationsDropdownController)

import SupportStatusController from "./support_status_controller"
application.register("support-status", SupportStatusController)

import NotifyAgentsController from "./notify_agents_controller"
application.register("notify-agents", NotifyAgentsController)

import NpnRecoveryController from "./npn_recovery_controller"
application.register("npn-recovery", NpnRecoveryController)

import NpnPurchaseGateController from "./npn_purchase_gate_controller"
application.register("npn-purchase-gate", NpnPurchaseGateController)

import NpnValidateController from "./npn_validate_controller"
application.register("npn-validate", NpnValidateController)

import OnboardingAgreementsController from "./onboarding_agreements_controller"
application.register("onboarding-agreements", OnboardingAgreementsController)

import OnboardingController from "./onboarding_controller"
application.register("onboarding", OnboardingController)

import OrderPriceQuoteController from "./order_price_quote_controller"
application.register("order-price-quote", OrderPriceQuoteController)

import OrgConfirmGateController from "./org_confirm_gate_controller"
application.register("org-confirm-gate", OrgConfirmGateController)

import OrgSuggestionController from "./org_suggestion_controller"
application.register("org-suggestion", OrgSuggestionController)

import OutgoingWebhookFormController from "./outgoing_webhook_form_controller"
application.register("outgoing-webhook-form", OutgoingWebhookFormController)

import PasswordMatchController from "./password_match_controller"
application.register("password-match", PasswordMatchController)

import PasswordStrengthController from "./password_strength_controller"
application.register("password-strength", PasswordStrengthController)

import PasswordVisibilityController from "./password_visibility_controller"
application.register("password-visibility", PasswordVisibilityController)

import LoginTelemetryController from "./login_telemetry_controller"
application.register("login-telemetry", LoginTelemetryController)

import PhoneFormatController from "./phone_format_controller"
application.register("phone-format", PhoneFormatController)

import PhoneVerificationInlineController from "./phone_verification_inline_controller"
application.register("phone-verification-inline", PhoneVerificationInlineController)

import PhotoCropController from "./photo_crop_controller"
application.register("photo-crop", PhotoCropController)

import HeadshotGenerationController from "./headshot_generation_controller"
application.register("headshot-generation", HeadshotGenerationController)

import ProductPageToggleController from "./product_page_toggle_controller"
application.register("product-page-toggle", ProductPageToggleController)

import ProfilePhotoController from "./profile_photo_controller"
application.register("profile-photo", ProfilePhotoController)

import ProperCaseController from "./proper_case_controller"
application.register("proper-case", ProperCaseController)

import PublicHomeController from "./public_home_controller"
application.register("public-home", PublicHomeController)

import QuietHoursController from "./quiet_hours_controller"
application.register("quiet-hours", QuietHoursController)

import CrmLaunchCountdownController from "./crm_launch_countdown_controller"
application.register("crm-launch-countdown", CrmLaunchCountdownController)

// One bridge class serves every React island; each identifier keeps its
// existing name (and identifier-scoped value attributes) — the identifier
// resolves the mount function inside ReactBridgeController (audit F37).
import ReactBridgeController from "./react_bridge_controller"
application.register("react-ai-assistant-bridge", ReactBridgeController)
application.register("react-crm-billing-bridge", ReactBridgeController)
application.register("react-crm-setup-bridge", ReactBridgeController)
application.register("react-crm-setup-launcher-bridge", ReactBridgeController)
application.register("react-workflows-bridge", ReactBridgeController)
application.register("react-conversations-bridge", ReactBridgeController)
application.register("react-datatable-bridge", ReactBridgeController)
application.register("react-email-composer-bridge", ReactBridgeController)
application.register("react-expense-dashboard-bridge", ReactBridgeController)
application.register("react-expense-review-grid-bridge", ReactBridgeController)
application.register("react-goat-connect-softphone-bridge", ReactBridgeController)
application.register("react-guides-bridge", ReactBridgeController)
application.register("react-imo-agency-picker-bridge", ReactBridgeController)
application.register("react-tag-list-picker-bridge", ReactBridgeController)
application.register("react-add-custom-field-bridge", ReactBridgeController)
application.register("react-lead-score-calibration-bridge", ReactBridgeController)
application.register("react-lead-vendor-bridge", ReactBridgeController)
application.register("react-phone-my-numbers-bridge", ReactBridgeController)
application.register("react-verified-caller-id-bridge", ReactBridgeController)
application.register("react-quick-schedule-bridge", ReactBridgeController)
application.register("react-settings-notes-bridge", ReactBridgeController)
application.register("react-wrap-up-buttons-bridge", ReactBridgeController)

import RealtimeOrderController from "./realtime_order_controller"
application.register("realtime-order", RealtimeOrderController)

import ResourceSearchController from "./resource_search_controller"
application.register("resource-search", ResourceSearchController)

import RloCrmChoiceController from "./rlo_crm_choice_controller"
application.register("rlo-crm-choice", RloCrmChoiceController)
import VoucherRefillSetupController from "./voucher_refill_setup_controller"
application.register("voucher-refill-setup", VoucherRefillSetupController)

import RloSectionController from "./rlo_section_controller"
application.register("rlo-section", RloSectionController)

import RowExpandController from "./row_expand_controller"
application.register("row-expand", RowExpandController)

import SearchInputController from "./search_input_controller"
application.register("search-input", SearchInputController)

import SecretRevealController from "./secret_reveal_controller"
application.register("secret-reveal", SecretRevealController)

import SettingInfoModalController from "./setting_info_modal_controller"
application.register("setting-info-modal", SettingInfoModalController)

import SettingsTabsController from "./settings_tabs_controller"
application.register("settings-tabs", SettingsTabsController)

import OverflowCuesController from "./overflow_cues_controller"
application.register("overflow-cues", OverflowCuesController)

import SettingsNavigationController from "./settings_navigation_controller"
application.register("settings-navigation", SettingsNavigationController)

import SidebarGroupController from "./sidebar_group_controller"
application.register("sidebar-group", SidebarGroupController)

import SidebarModeController from "./sidebar_mode_controller"
application.register("sidebar-mode", SidebarModeController)

import SidebarScrollController from "./sidebar_scroll_controller"
application.register("sidebar-scroll", SidebarScrollController)

import SoftphoneDialController from "./softphone_dial_controller"
application.register("softphone-dial", SoftphoneDialController)

import SoftphoneOpenController from "./softphone_open_controller"
application.register("softphone-open", SoftphoneOpenController)

import SidebarSectionController from "./sidebar_section_controller"
application.register("sidebar-section", SidebarSectionController)

import SignatureEnableController from "./signature_enable_controller"
application.register("signature-enable", SignatureEnableController)

import SignaturePreviewController from "./signature_preview_controller"
application.register("signature-preview", SignaturePreviewController)

import SignupSupportController from "./signup_support_controller"
application.register("signup-support", SignupSupportController)

import SlackChannelCreateController from "./slack_channel_create_controller"
application.register("slack-channel-create", SlackChannelCreateController)

import SlugVerifyController from "./slug_verify_controller"
application.register("slug-verify", SlugVerifyController)

import SortableController from "./sortable_controller"
application.register("sortable", SortableController)

import SourceEditModalController from "./source_edit_modal_controller"
application.register("source-edit-modal", SourceEditModalController)

import SpamProtectorToastController from "./spam_protector_toast_controller"
application.register("spam-protector-toast", SpamProtectorToastController)

import SpamProtectorCleanController from "./spam_protector_clean_controller"
application.register("spam-protector-clean", SpamProtectorCleanController)

import SpamProtectorAgentNumbersController from "./spam_protector_agent_numbers_controller"
application.register("spam-protector-agent-numbers", SpamProtectorAgentNumbersController)

import SpamProtectorStartGateController from "./spam_protector_start_gate_controller"
application.register("spam-protector-start-gate", SpamProtectorStartGateController)

import FrameModalController from "./frame_modal_controller"
application.register("frame-modal", FrameModalController)

import StateLicensePickerController from "./state_license_picker_controller"
application.register("state-license-picker", StateLicensePickerController)

import StateLicenseDetailsController from "./state_license_details_controller"
application.register("state-license-details", StateLicenseDetailsController)

import SupportHoursRowController from "./support_hours_row_controller"
application.register("support-hours-row", SupportHoursRowController)

import SupportTopicSearchController from "./support_topic_search_controller"
application.register("support-topic-search", SupportTopicSearchController)

import SupportWorkTicketController from "./support_work_ticket_controller"
application.register("support-work-ticket", SupportWorkTicketController)

import SurveyModalController from "./survey_modal_controller"
application.register("survey-modal", SurveyModalController)

import TagsManagerController from "./tags_manager_controller"
application.register("tags-manager", TagsManagerController)

import ThemeToggleController from "./theme_toggle_controller"
application.register("theme-toggle", ThemeToggleController)

import TicketContextFieldsController from "./ticket_context_fields_controller"
application.register("ticket-context-fields", TicketContextFieldsController)

import TimeClockController from "./time_clock_controller"
application.register("time-clock", TimeClockController)

import ToggleFieldController from "./toggle_field_controller"
application.register("toggle-field", ToggleFieldController)

import TopicDeflectionController from "./topic_deflection_controller"
application.register("topic-deflection", TopicDeflectionController)

import TrustCenterReviewSubmitController from "./trust_center_review_submit_controller"
application.register("trust-center-review-submit", TrustCenterReviewSubmitController)

import TrustCenterCarrierApprovalController from "./trust_center_carrier_approval_controller"
application.register("trust-center-carrier-approval", TrustCenterCarrierApprovalController)

import TrustCenterCampaignKitController from "./trust_center_campaign_kit_controller"
application.register("trust-center-campaign-kit", TrustCenterCampaignKitController)

import TrustCenterComplianceWebsiteController from "./trust_center_compliance_website_controller"
application.register("trust-center-compliance-website", TrustCenterComplianceWebsiteController)

import TrustCenterStaffActionsController from "./trust_center_staff_actions_controller"
application.register("trust-center-staff-actions", TrustCenterStaffActionsController)

import TrustCenterOtpController from "./trust_center_otp_controller"
application.register("trust-center-otp", TrustCenterOtpController)

import TrustCenterWizardController from "./trust_center_wizard_controller"
application.register("trust-center-wizard", TrustCenterWizardController)

import TurnstileController from "./turnstile_controller"
application.register("turnstile", TurnstileController)

import UnitAmountRangeController from "./unit_amount_range_controller"
application.register("unit-amount-range", UnitAmountRangeController)

import UnsavedChangesController from "./unsaved_changes_controller"
application.register("unsaved-changes", UnsavedChangesController)

import UserEditController from "./user_edit_controller"
application.register("user-edit", UserEditController)

import VerificationGateController from "./verification_gate_controller"
application.register("verification-gate", VerificationGateController)

import VerificationRescueController from "./verification_rescue_controller"
application.register("verification-rescue", VerificationRescueController)

import VoiceDemoDataController from "./voice_demo_data_controller"
application.register("voice-demo-data", VoiceDemoDataController)

import VoiceNoteRecorderController from "./voice_note_recorder_controller"
application.register("voice-note-recorder", VoiceNoteRecorderController)

import VoucherBalanceCheckController from "./voucher_balance_check_controller"
application.register("voucher-balance-check", VoucherBalanceCheckController)

import W9FormController from "./w9_form_controller"
application.register("w9-form", W9FormController)

import SignaturePadController from "./signature_pad_controller"
application.register("signature-pad", SignaturePadController)

import WebhookMappingFormController from "./webhook_mapping_form_controller"
application.register("webhook-mapping-form", WebhookMappingFormController)

import WebhookTestController from "./webhook_test_controller"
application.register("webhook-test", WebhookTestController)

import WhitelabelPreviewController from "./whitelabel_preview_controller"
application.register("whitelabel-preview", WhitelabelPreviewController)

import WorkflowMaintenanceRunController from "./workflow_maintenance_run_controller"
application.register("workflow-maintenance-run", WorkflowMaintenanceRunController)
